import React from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

import { SeoHelper } from "../../components/helpers/SeoHelper";

class Security extends React.Component {

  render() {
    return (
        <>
          <SeoHelper
              uri="/security"
              title = "Security & Data Protection | The Worship Bible"
              description="How The Worship Bible protects your data using responsible, proportionate security practices designed for churches."
          />

          {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>security &amp; data protection</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>


          {/* Content */}
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Card className="shadow border-0">
                    <CardBody className="py-5 terms-content">
                      <h2
                          style={{ fontSize: "1rem" }}
                          className="text-primary text-uppercase pt-3 pb-3"
                      >
                        Security &amp; Data Protection Statement
                      </h2>

                      <p><strong>The Worship Bible</strong></p>
                      <p><strong>Last updated: 7 February 2026</strong></p>

                      <hr />

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Our Commitment
                      </h3>
                      <p>
                        The Worship Bible is committed to protecting the security, privacy,
                        and integrity of the data entrusted to us. We take a responsible,
                        proportionate approach to information security that reflects the
                        nature of our service and the needs of churches and worship leaders.
                      </p>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Data We Collect
                      </h3>
                      <p>We collect only the minimum data required to operate the service effectively, which may include:</p>
                      <ul style={{ marginTop: 0 + "cm", fontWeight: 300 }} type="square" className="MsoNormal">
                        <li>Name and email address</li>
                        <li>Account and subscription information</li>
                        <li>User-generated content (e.g. song flows or playlists)</li>
                      </ul>
                      <p>
                        We do not store or process payment card details. All payments are
                        handled securely by our third-party payment provider.
                      </p>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Payment Security
                      </h3>
                      <p>
                        Payments are processed by Stripe, a PCI-DSS compliant payment
                        provider. The Worship Bible never stores or has access to full card
                        details.
                      </p>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Access Control &amp; Authentication
                      </h3>
                      <ul style={{ marginTop: 0 + "cm", fontWeight: 300 }} type="square" className="MsoNormal">
                        <li>User accounts are protected by securely hashed passwords</li>
                        <li>Administrative access is restricted to authorised personnel only</li>
                        <li>Access is granted on a least-privilege basis</li>
                        <li>Sensitive systems are protected by environment-based secrets and secure credentials</li>
                      </ul>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Infrastructure &amp; Hosting Security
                      </h3>
                      <ul style={{ marginTop: 0 + "cm", fontWeight: 300 }} type="square" className="MsoNormal">
                        <li>All traffic to and from the platform is encrypted using HTTPS</li>
                        <li>Production systems are isolated using containerisation</li>
                        <li>Security updates and patches are applied regularly</li>
                        <li>Logs and monitoring are in place to detect unusual behaviour</li>
                      </ul>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Data Protection &amp; GDPR
                      </h3>
                      <p>
                        We comply with UK GDPR and EU GDPR requirements, including:
                      </p>
                      <ul style={{ marginTop: 0 + "cm", fontWeight: 300 }} type="square" className="MsoNormal">
                        <li>Lawful, transparent data processing</li>
                        <li>Purpose limitation and data minimisation</li>
                        <li>Secure handling of personal data</li>
                        <li>Respect for user rights, including access and deletion requests</li>
                      </ul>
                      <p>
                        Users may request access to or deletion of their data at any time by
                        contacting us.
                      </p>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Backups &amp; Availability
                      </h3>
                      <ul style={{ marginTop: 0 + "cm", fontWeight: 300 }} type="square" className="MsoNormal">
                        <li>Regular backups are taken to protect against data loss</li>
                        <li>Backup data is stored securely</li>
                        <li>Recovery procedures are tested periodically</li>
                      </ul>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Incident Response
                      </h3>
                      <p>In the event of a security incident:</p>
                      <ul style={{ marginTop: 0 + "cm", fontWeight: 300 }} type="square" className="MsoNormal">
                        <li>We will investigate promptly</li>
                        <li>Take appropriate steps to contain and resolve the issue</li>
                        <li>Notify affected users and regulators where legally required</li>
                      </ul>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Our Security Approach
                      </h3>
                      <p>
                        While The Worship Bible is not formally certified to ISO/IEC 27001,
                        we operate in line with recognised information-security best
                        practices and the principles of that standard, proportionate to our
                        size and risk profile.
                      </p>
                      <p>
                        Security is reviewed continuously as the platform grows.
                      </p>

                      <h3 style={{ fontSize: "1rem" }} className="MsoNormal text-primary">
                        Contact
                      </h3>
                      <p>
                        If you have any questions about security or data protection, please
                        contact:
                      </p>
                      <p>
                        Email:{" "}
                        <a href="mailto:support@theworshipbible.church">
                          support@theworshipbible.church
                        </a>
                        <br />
                        Website:{" "}
                        <a href="https://theworshipbible.church">
                          https://theworshipbible.church
                        </a>
                      </p>

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </>
    );
  }
}

export default Security;